import React, {useEffect, useState} from 'react';
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterPalletStatus} from "../../microComponents/tablePages/getFilterPalletStatus";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import GetProductList from "../Products/GetProductList";
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";
import DebouncingInputFilter from "../../microComponents/tablePages/filter/DebouncingInputFilter";
import {allowLoadJson} from "../../helper/jsons/activatedJson";
import DateFilter from "../../microComponents/tablePages/filter/DateFilter";


const TopSearchPalletStatus = () => {


    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);

    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterPalletStatus, setFilterPalletStatus] = useState([]);
    const [palletStatusLoading, setPalletStatusLoading] = useState(false);

    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);

    const [filterLocation, setFilterLocation] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);

    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);


    useEffect(() => {
        GetProductList(setProductList, setProductListLoading)
        getFilterDetailsList(setFilterDetailsList, setFilterDetailsListLoading)
        getFilterProductLine(setFilterProductLine, setProductLineLoading)
        getFilterBranch(setFilterBranch, setBranchLoading)
        getFilterPalletStatus(setFilterPalletStatus, setPalletStatusLoading)
        getFilterLocation(setFilterLocation, setLocationLoading)
        getFilterQcStatus(setQcStatusList, setQcStatusLoading)

    }, [])
    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>


        <FilterSelectOption data={{
            filterName: 'unitMeasurement',

            loading: filterDetailsListLoading,
            placeholder: 'واحد سنجش',
            options: filterDetailsList.unitMeasurement
        }}/>

        <FilterSelectOption data={{
            filterName: 'type',

            loading: filterDetailsListLoading,
            placeholder: 'نوع',
            options: filterDetailsList.type
        }}/>


        <FilterSelectOption data={{
            filterName: 'product',
            className: '2xs:hidden',
            loading: productListLoading,
            placeholder: 'محصول',
            options: productList
        }}/>


        <FilterSelectOption data={{
            filterName: 'brand',
            className: 'sm:hidden',
            loading: filterDetailsListLoading,
            placeholder: 'برند',
            options: filterDetailsList?.brand
        }}/>

        <FilterSelectOption data={{
            filterName: 'productLine',
            className: 'md:hidden',
            loading: productLineLoading,
            placeholder: 'خط تولید',
            options: filterProductLine
        }}/>

        <FilterSelectOption data={{
            filterName: 'palletStatus',
            className: 'md:hidden',
            loading: palletStatusLoading,
            placeholder: 'وضعیت',
            options: filterPalletStatus
        }}/>


        <FilterSelectOption data={{
            placeholder: 'واحد',
            filterName: 'branch',
            className: '2md:hidden',

            options: filterBranch,
            loading: branchLoading,

        }}/>


        <FilterSelectOption data={{
            placeholder: 'موقعیت',
            filterName: 'locations',
            className: 'lg:hidden',

            options: filterLocation,
            loading: locationLoading,

        }}/>

        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'ق.ت',
                filterName: 'manufacturerPriceRials',

            }}
        />
        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: ' ق.م',
                filterName: 'consumerPriceRials',

            }}
        />


        <DateFilter
            data={{
                className: 'lg:hidden',
                placeholder: ['زمان تولید تا', 'زمان تولید از'],
                filterName: ['fromProduceDate', 'toProduceDate'],
            }}
        />


        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'بچ',

                filterName: 'batchNumber',
            }}
        />

        <FilterSelectOption data={{
            placeholder: 'QC',
            filterName: 'qcStatus',
            className: 'lg:hidden',

            options: qcStatusList,
            loading: qcStatusLoading,

        }}/>
        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'کارشناس QC',

                filterName: 'qualityControlSupervisor',
            }}
        />

        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'سرپرست تولید',

                filterName: 'seriCreateBy',
            }}
        />


        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'شماره حواله',

                filterName: 'orderCode',
            }}
        />

        <FilterSelectOption data={{
            placeholder: 'بارگیری',
            filterName: 'allowLoad',
            className: 'lg:hidden',

            options: allowLoadJson,

        }}/>


    </div>);
};

export default TopSearchPalletStatus;
